// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".passporte {\n  background-color: #0d2b42;\n  padding-left: 12px;\n  padding-right: 12px;\n  border-radius: 4px;\n  margin-right: 10px;\n}\n.passporte p {\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
